import { render, staticRenderFns } from "./register_view.vue?vue&type=template&id=35035822&"
import script from "./register_view.vue?vue&type=script&lang=js&"
export * from "./register_view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports